import BaseObject from "../base/base_object";
import ObservableFactory from "./observable_factory";
import {IObservableSubscription} from "./observable";

export interface RetryItem {
  durationInSeconds: number;
  repeatTimes: number;
}

export interface IReconnectHelperParams {
    retryFunc(): void,
    retryIntervals: RetryItem[],
    name: string
}

export interface IReconnectHelper{
  init(params:IReconnectHelperParams);
  getNumberOfRetries(): number;
  start(): void;
  stop(): void;
}

export default class ReconnectHelper extends BaseObject implements IReconnectHelper{
    static CLASS='ReconnectHelper';

    _retryFunc = null;
    _retryIntervals: RetryItem[] = null;
    _currentIntervalIdx: number = 0; //current index of _retryIntervals
    _currentRepeatCount:number = 0; //repeatTimes count for current interval
    _numberOfRetries:number = 0;
    _reconnectTimerObservable:IObservableSubscription = null; //used for timeout connection // , dar da eroare
    _observableFactory:ObservableFactory = null;
    _serviceName: string;

    init(params:IReconnectHelperParams){
        this._retryFunc = params.retryFunc || null;
        this._retryIntervals = params.retryIntervals || [];
        this._serviceName = params.name || "UNKNOWN SERVICE USING RECONNECT HELPER";
        this._observableFactory = ObservableFactory.create();
    }

    getNumberOfRetries(): number {
        return this._numberOfRetries;
    }

    /**
     * call connect function and if it fails, it will start the reconnection process
     */
    start() {
        this._callConnectFunction();
    }

    /**
     * clears timeout and resets counters
     */
    stop() {
        this._currentIntervalIdx = 0;
        this._currentRepeatCount = 0;
        this._numberOfRetries = 0;

        this._clearTimeout();
    }

    /**
     * starts timeout and call connection function
     */
    private _startTimeout() {
        this._clearTimeout();
        this._numberOfRetries++;
        let currentInterval = this._retryIntervals[this._currentIntervalIdx];

        this._reconnectTimerObservable = this._observableFactory.fromTimeout(currentInterval.durationInSeconds * 1000)
            .forEach(() => {
                if (currentInterval.repeatTimes > 0) {
                    this._currentRepeatCount++;
                    if (this._currentRepeatCount === currentInterval.repeatTimes) {
                        this._currentIntervalIdx++;
                        this._currentRepeatCount = 0;
                        if (this._currentIntervalIdx >= this._retryIntervals.length) {
                            this.stop();
                            return;
                        }
                    }
                }
                // call connect function and if it fails it will renew the timout ( continues reconnection process )
                this._callConnectFunction();
            })
    }

    /**
     * calls reconnection function. if successful, stops the helper, otherwise restarts the timeout
     */
    private _callConnectFunction() {
        this._retryFunc()
            .then(() => {
                this.logger.info(`${this._serviceName} RECONNECT HELPER :: CONNECTION SUCCESSFUL ON ATTEMPT ${this._numberOfRetries}`);
                this.stop();
            })
            .catch(() => {
                this.logger.info(`${this._serviceName} RECONNECT HELPER :: CONNECTION FAILED, RECONNECT ATTEMPT ${this._numberOfRetries}, RETRY INTERVAL ATTEMPT NO: ${this._currentRepeatCount}`, this._retryIntervals[this._currentIntervalIdx]);
                this._startTimeout();
            });
    }

    /**
     * clears the retry timeout
     */
    private _clearTimeout() {
        if (this._reconnectTimerObservable) {
            this._reconnectTimerObservable.dispose();
            this._reconnectTimerObservable = null;
        }
    }
}